import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-ignore Untyped module
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import FormattedPrice from 'payments-checkout-lib/components/Utilities/FormattedPrice';
import { getIsZeroCheckoutValid } from '../../utils/validations';
import BalanceDueSummary from './BalanceDueSummary';
import TotalsValidationMessages from './TotalsValidationMessages';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import useBuyerOverridesLoading from '../../hooks/useBuyerOverridesLoading';
import { CREDIT_MEMOS_GATE } from '../../constants/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Total = ({
  checkoutSession,
  hasFutureCharges,
  selectedOptionalLineItems
}) => {
  var _checkoutSession$gate;
  const currencyCode = checkoutSession.currencyCode;
  const nativeCurrencySymbol = getNativeCurrencySymbol(currencyCode);
  const isZeroCheckout = getIsZeroCheckoutValid(checkoutSession.subtotalsPublicResponse && checkoutSession.subtotalsPublicResponse.paymentAmount, checkoutSession.lineItems);
  const {
    amountPaid,
    balanceDue,
    isPartialPaymentsEnabled
  } = checkoutSession.partialPaymentsInfo || {};
  const isBuyerOverridesLoading = useBuyerOverridesLoading();
  const isUngatedToCreditMemos = (_checkoutSession$gate = checkoutSession.gates) === null || _checkoutSession$gate === void 0 ? void 0 : _checkoutSession$gate.includes(CREDIT_MEMOS_GATE);
  const creditMemos = isUngatedToCreditMemos ? checkoutSession.creditMemos : [];
  const hasPartialPaymentsOrCreditMemos = isUngatedToCreditMemos ? creditMemos.length > 0 || !!amountPaid : !!amountPaid;
  const showBalanceDueSummary = hasPartialPaymentsOrCreditMemos && !!balanceDue;
  const leftGridSize = 4;
  const rightGridSize = 8;
  const totalMessage = useMemo(() => {
    if (isZeroCheckout || hasFutureCharges) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.dueNow",
        options: {
          currencyCode
        }
      });
    } else if (showBalanceDueSummary) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.total"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.totalWithISO",
      options: {
        currencyCode
      }
    });
  }, [currencyCode, isZeroCheckout, showBalanceDueSummary, hasFutureCharges]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Grid, {
      paddingInline: "600",
      paddingBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: leftGridSize,
        children: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          typography: showBalanceDueSummary ? 'body-400' : 'heading-300',
          marginBlockEnd: "200",
          textAlign: "start",
          children: totalMessage
        })
      }), /*#__PURE__*/_jsxs(GridItem, {
        size: rightGridSize,
        "data-test-id": "summary-total-text",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: showBalanceDueSummary ? 'body-400' : 'heading-300',
          marginBlockEnd: "200",
          textAlign: "end",
          color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default',
          children: checkoutSession.total ? /*#__PURE__*/_jsx(FormattedPrice, {
            currencyCode: currencyCode,
            price: checkoutSession.total,
            currencyAndAmountStyle: {
              color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
            }
          }) : isZeroCheckout ?
          /*#__PURE__*/
          // $ 0.00
          _jsx("span", {
            "data-test-id": "zero-total",
            children: /*#__PURE__*/_jsx(FormattedPrice, {
              currencyCode: currencyCode,
              price: checkoutSession.total,
              currencyAndAmountStyle: {
                color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
              }
            })
          }) :
          /*#__PURE__*/
          // $ --
          _jsx("span", {
            "data-test-id": "pay-open-amount-message",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "payments.openAmount",
              options: {
                currencySymbol: nativeCurrencySymbol
              }
            })
          })
        }), !isPartialPaymentsEnabled && /*#__PURE__*/_jsx(TotalsValidationMessages, {
          checkoutSession: checkoutSession,
          selectedOptionalLineItems: selectedOptionalLineItems
        })]
      })]
    }), showBalanceDueSummary && /*#__PURE__*/_jsx(BalanceDueSummary, {
      amountPaid: amountPaid || 0,
      balanceDue: balanceDue,
      creditMemos: creditMemos,
      currencyCode: currencyCode,
      leftGridSize: leftGridSize,
      rightGridSize: rightGridSize
    })]
  });
};
export default Total;